var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "ul",
        { class: { grid: true, "grid--loading": _vm.$wait.is("users") } },
        [
          _vm.error
            ? _c("li", { staticClass: "grid__error col-12" }, [
                _c("span", { staticClass: "h2" }, [
                  _vm._v("Unable to load users."),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn--link",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.load.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v("Retry")]
                ),
              ])
            : _vm.users
            ? _vm._l(_vm.users, function (user) {
                return _c(
                  "li",
                  { staticClass: "col-md-4" },
                  [_c("UserCard", { attrs: { user: user } })],
                  1
                )
              })
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c("paginate", {
        attrs: {
          "page-count": _vm.max_page,
          "page-range": 3,
          "margin-pages": 1,
          "click-handler": _vm.getUsers,
          "hide-prev-next": true,
          "container-class": "pagination",
          "page-class": "page-item",
          "active-class": "page-item--active",
        },
        model: {
          value: _vm.page,
          callback: function ($$v) {
            _vm.page = $$v
          },
          expression: "page",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }